enum ConnectionFormType {
    Regular = 'Regular',
    WorshipService = 'WorshipService',
    Quiz = 'Quiz',
}

export default ConnectionFormType;
